import React from 'react';
import { Box, Typography } from '@ublend-npm/aulaui-core';
import NoResultsCard from '@app/components/presentational/common/NoResults/NoResultsCard';
import StudentRow from './StudentRow';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  onToggleStudent: (studentId: string) => void;
  selectedIds: string[];
  students: ExtensionStudent[];
  styles: ManageExtensionStyles;
  extensionName?: string;
};

const CohortStudentsList = ({
  onToggleStudent,
  selectedIds,
  students,
  styles,
  extensionName,
}: Props) => {
  const addedStudents = students.filter(({ id }) => selectedIds.includes(id));
  const notAddedStudents = students.filter(
    ({ id }) => !selectedIds.includes(id)
  );
  const orderedStudents = [...addedStudents, ...notAddedStudents];
  const remainingStudents = notAddedStudents.length;
  const label = `(${remainingStudents})`;
  return (
    <Box sx={styles.studentsStep}>
      <Typography component="h3" sx={styles.cohortTitle}>
        Main cohort {remainingStudents > 0 && label}
      </Typography>
      {orderedStudents.length === 0 && (
        <NoResultsCard
          title="No student found!"
          description="There are no students in this cohort."
          sx={styles.emptyStudents}
          titleSx={styles.emptyStudentsTitle}
        />
      )}
      <Box component="ul" sx={styles.studentList}>
        {orderedStudents.map((student) => {
          const isSelected = selectedIds.includes(student.id);

          return (
            <StudentRow
              key={student.id}
              canAdd
              isDimmed={isSelected}
              isSelected={isSelected}
              onToggle={onToggleStudent}
              showAction={!isSelected}
              student={student}
              styles={styles}
              extensionName={extensionName}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default CohortStudentsList;
